import React from "react";
import PlpPromotionList from "./plp-promotion-list";
import reduxModules from "../common/redux/nextjs-modules";
import { fetchPlpState } from "../common/redux/reducers/index";

function PlpPromotionListMaster(props) {
  return (
    <React.Fragment>
      <PlpPromotionList {...props}/>
    </React.Fragment>
  );
}

PlpPromotionListMaster.reduxModules = reduxModules;

PlpPromotionListMaster.getInitialProps = async function (context) {
 await context.store.dispatch(fetchPlpState("", "promotion-list"));
};

export default PlpPromotionListMaster;
